import { Box, List, ListItem, Typography } from "@mui/material";
import {
  extraServiceReturnOptions,
  termsAndConditionsData,
} from "common/constants/extra-service-info";
import LazyImage from "components/LazyImage";
import { Span } from "components/Typography";
import { FC, Fragment, memo } from "react";

type Props = {};

const Component: FC<Props> = () => {
  return (
    <Fragment>
      <Box mt={3} sx={{ cursor: "pointer" }}>
        <LazyImage
          sx={{
            width: "100%",
            borderRadius: "8.8px",
            border: "2px solid red",
          }}
          width={850}
          height={280}
          alt={`/assets/images/extra-service/extra-service-mini.png`}
          loading="eager"
          objectFit="contain"
          src={"/assets/images/extra-service/extra-service-mini.png"}
        />
      </Box>
      <Box>
        <Typography
          fontSize={{
            xs: "32px",
            lg: "38px",
          }}
          ml={-0.5}
          fontWeight={900}
        >
          {extraServiceReturnOptions?.main_title}
        </Typography>
        <Box>
          <List>
            {extraServiceReturnOptions.data.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  paddingLeft: 0,
                  alignItems: "flex-start",
                  flexDirection: "row",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: "bold",
                    mr: 1,
                    fontSize: { xs: "16px", lg: "20px" },
                  }}
                >
                  {index + 1}.
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    sx={{ mr: 1, fontSize: { xs: "16px", lg: "20px" } }}
                  >
                    <Span sx={{ fontWeight: "bold" }}> {item?.title}: </Span>
                    {item?.content}.
                  </Typography>
                  <Box>
                    {item?.bullets?.map((bullet, index) => (
                      <List
                        key={index}
                        sx={{ listStyleType: "disc", ml: { xs: 3, lg: 5 } }}
                      >
                        <ListItem
                          sx={{ display: "list-item", padding: 0, mb: -2 }}
                        >
                          <Typography
                            sx={{ fontSize: { xs: "16px", lg: "20px" } }}
                          >
                            {bullet}
                          </Typography>
                        </ListItem>
                      </List>
                    ))}
                  </Box>
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
        <Typography
          sx={{ mr: 1, fontSize: { xs: "16px", lg: "20px" }, mt: 1.5 }}
        >
          {extraServiceReturnOptions.sub_content}
        </Typography>
      </Box>

      <Box mt={{ xs: 5, lg: 10 }}>
        <Typography
          fontSize={{ xs: "32px", lg: "38px" }}
          ml={-0.5}
          fontWeight={900}
        >
          {termsAndConditionsData?.main_title}
        </Typography>
        <Typography
          sx={{ mr: 1, fontSize: { xs: "16px", lg: "20px" }, mt: 1.5 }}
        >
          {termsAndConditionsData.sub_content}
        </Typography>
        <Box>
          <List>
            {termsAndConditionsData.data.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  paddingLeft: 0,
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: "bold",
                      mr: 1,
                      fontSize: { xs: "18px", lg: "24px" },
                    }}
                  >
                    {`${index + 1}.  ${item.title}`}.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    ml: { xs: 2.5, lg: 3.5 },
                  }}
                >
                  <Box>
                    {item?.bullets?.map((bullet, index) => (
                      <List
                        key={index}
                        sx={{ listStyleType: "disc", ml: { xs: 3, lg: 5 } }}
                      >
                        <ListItem
                          sx={{ display: "list-item", padding: 0, mb: -2 }}
                        >
                          <Typography
                            sx={{ fontSize: { xs: "16px", lg: "20px" } }}
                          >
                            {item?.bold_text[index] && (
                              <Span
                                fontWeight={"bold"}
                              >{`${item?.bold_text[index]} `}</Span>
                            )}
                            {`${bullet}`}
                          </Typography>
                        </ListItem>
                      </List>
                    ))}
                  </Box>
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
        <Typography
          sx={{ mr: 1, fontSize: { xs: "16px", lg: "20px" }, mt: 1.5 }}
        >
          {termsAndConditionsData.sub_footer_content}
        </Typography>
      </Box>
    </Fragment>
  );
};

export const ExtraServiceReturnTerms = memo(Component);
